import moment from 'moment';
import { TitreEntity } from '../../../../entities/titre.entity';
import {
  ExportFormat,
  ExportMetadata,
  exportPremiumFile,
} from '../../../../shared/exportFiles';

export const generateTitreDataToExport = (titres: TitreEntity[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let b of titres) {
    toExport.push({
      Index: index,
      Code: b.code,
      Emetteur: b.pays,
      Instrument: b.instrument,
      'Date Emission': b.dateEmission,
      'Date Maturite': b.dateMaturite,
      'Duree Maturite': b.dureeMaturite,
      Coupon: b.tauxMarginal,
      'Valeur Nominale': b.valeurNominale,
      'Fréquence de Paiement': b.frequencePaiement,
      'Date création': `${moment(b.created_at).format('DD/MM/YYYY HH:mm:ss')}`,
    });
    index += 1;
  }

  return toExport;
};

export const generateTitreDetailDataToExport = (titres: TitreEntity[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let titre of titres) {
    for (let det of titre.details || []) {
      toExport.push({
        Index: index,
        Code: det.parentCode,
        'Sous code': det.subCode,
        Emetteur: titre.pays,
        Instrument: titre.instrument,
        'Date Emission': titre.dateEmission,
        'Date Maturite': titre.dateMaturite,
        'Duree Maturite': titre.dureeMaturite,
        Etat: det.etat,
        Quantite: det.qte,
        'Montant total': det.montant,
        Prix: det.prixNominale,
        'Décote (%)': det.decote,
        'Coupon (%)': titre.tauxMarginal,
        'Rendement (%)': det.tauxRendement,
        'Code origin': det.originCode,
        'Code client': det.detenteur?.code_referent || '',
        'Nom client': `${det.detenteur?.nom || ''} ${det.detenteur?.prenom || ''}`.trim(),
        'Date acquisition': `${moment(det.dateAcquisition).format(
          'DD/MM/YYYY',
        )}`,
        'Coupon Couru à Payer': det.couponCouruPayer,
        'Coupon à Percevoir': det.couponPercevoir,
        'Commission Total': det.commissionTotal,
      });
      index += 1;
    }
  }

  return toExport;
};

export const exportTitresData = (
  titres: TitreEntity[],
  format: ExportFormat,
  metadata?: ExportMetadata,
) => {
  const titresData = generateTitreDataToExport(titres);
  const titreDetailsData = generateTitreDetailDataToExport(titres);

  exportPremiumFile({
    fileName: 'Etat des titres',
    metadata,
    title: 'Etat des titres',
    sheets: [
      { data: titresData, name: 'Etat des titres' },
      { data: titreDetailsData, name: 'Etat detaille des titres' },
    ],
  }, format);
};
